import { IStepComponentProps } from "@shared/components/form/types";
import { ActivityName } from "app/_modules/core/types";
import { MeasurementForm } from "app/_modules/core/components/forms";
import { TMeasurementResponse } from "app/_modules/pathways/entities";

export interface IMeasurementManualStepContext {
  activityName: ActivityName;
  onSubmitSuccess: (result: TMeasurementResponse) => void;
}

export const MeasurementManualStep = ({ context }: IStepComponentProps<undefined, IMeasurementManualStepContext>) => {
  const activityName = context?.activityName!;
  const onSubmitSuccess = context?.onSubmitSuccess!;

  return (
    <MeasurementForm activityName={activityName} onSuccess={onSubmitSuccess} />
  );
};

export default MeasurementManualStep;
